import React from 'react';
import './style.css';

const ScrollHeader = () => {
  const text = 'Importerr is evolving in real time. You may notice small glitches and occasional delivery delays due to war-related disruptions as we continue improving every day. Your feedback helps us build better — thank you for being here early.';

  // Add spacer element after each text repetition
  const repeatedText = Array(5)
    .fill(null)
    .map((_, index) => (
      <React.Fragment key={index}>
        {text}
        <span className="text-spacer">•••</span>
      </React.Fragment>
    ));

  return (
    <div className="header-strip">
      <div className="scroll-container">
        <div className="scrolling-text">{repeatedText}</div>
        {/* Duplicate for seamless loop */}
        <div className="scrolling-text" aria-hidden="true">
          {repeatedText}
        </div>
      </div>
    </div>
  );
};

export default ScrollHeader;
